import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAuthenticated } from '@/shared/store/auth';

/**
 * Operator 라우트 (/agents/$agentId/operator/$executionId)
 *
 * beforeLoad 훅을 사용하여 비인증 사용자를 로그인으로 리다이렉트합니다.
 * 컴포넌트는 $executionId.lazy.tsx에서 자동으로 코드 스플리팅됩니다.
 */
export const Route = createFileRoute('/agents/$agentId/operator/$executionId')({
  beforeLoad: async ({ location }) => {
    if (!isAuthenticated()) {
      throw redirect({
        to: '/login',
        search: { redirect: location.pathname },
        replace: true, // 히스토리 대체 - 뒤로가기 시 로그인 페이지 건너뛰기
      });
    }
  },
});
